export const setSupportedCharacters = ( state, value ) => {
    state.supportedCharacters = value;
}

export const clearSupportedCharacters = ( state ) => {
    state.supportedCharacters = [];
}
